const preference = {
  title: "Preferences",
  account: {
    title: "My Account",
    subtitle: "Manage my account",
    avatar: "Avatar",
    username: "Username",
    email: "Email Address (Private)",
    introduction: "Introduction",
    introductionPlaceholder: "Enter an introduction",
    introductionDescription: "Your introduction will be displayed on 'Notes Nebura' and 'Studio Juno'.",
    modeSwitch: "Mode Switch",
    modeSwitchDescription: "Switch between personal and organization modes",
    switchToEnterprise: "Switch to Organization Mode",
    switchToPersonal: "Switch to Personal Mode",
    switchedToEnterprise: "Switched to Organization Mode",
    switchedToPersonal: "Switched to Personal Mode",
    deleteDialog: {
      title: "Deactivate Account",
      description:
        "Your account will be deactivated and you will no longer be able to log in. Some public data may remain accessible.",
      personalUser: "Your personal account will be deactivated. Any organization accounts will not be affected.",
      enterpriseUser: "Your organization account will be deactivated. Your personal account will not be affected.",
      lastOwner: "You are the last owner of the organization. Please promote another member to owner first.",
      confirm: "Deactivate",
      error: {
        common: "Failed to deactivate the account. Please contact support.",
        subscription:
          "You cannot deactivate your account because you are subscribed to a paid plan. Please cancel your plan and then deactivate your account.",
        owner_protection:
          "You cannot deactivate your account as you are the last owner of the organization. Please promote another member to owner first.",
        owner_protection_with_org:
          "You cannot deactivate your account as you are the last owner of the organization '{{organizationName}}'. Please promote another member to owner first.",
        deactivated: "Your account has been successfully deactivated.",
      },
    },
  },
  invitation: {
    title: "Organization Invitation",
    description: "Manage invitations sent to you",
    noInvitations: "There are no pending invitations",
    invitedBy: "Invited by",
    acceptedSuccess: "You have accepted the invitation to organization '{{organization}}'",
    declinedSuccess: "You have declined the invitation",
    acceptError: "Failed to accept the invitation",
    declineError: "Failed to decline the invitation",
    alreadyInOrganization: "You are already a member of an organization. You cannot accept new invitations.",
    leaveFirstMessage: "To join another organization, you must leave your current organization first.",
  },
  enterprise: {
    title: "Enterprise",
    noEnterpriseInfo: "Enterprise information is not available",
    notEnterpriseMode: "You are not in Enterprise Mode",
    info: "Organization Info",
    members: "Member Management",
    settings: "Organization Settings",
    usage: "Usage Report",
    readOnlyMode: "You can only view organization settings. Permission required for changes.",

    // Organization Info Component
    organizationDetails: "Organization Details",
    organizationName: "Organization Name",
    editName: "Edit Organization Name",
    contractPeriod: "Credit Expiration",
    fromTo: "From {{from}} to {{to}}",
    creditPool: "Credit Pool",
    creditUsage: "Credit Usage",
    memberCount: "Member Count",
    yourRole: "Your Role",
    role: {
      owner: "Owner",
      manager: "Manager",
      member: "Member",
    },
    selfEditDisabled: "You cannot change your own role",
    selfDeleteDisabled: "You cannot delete yourself",
    suspendMember: "Suspend Member",
    activateMember: "Activate Member",
    leave: "Leave Organization",
    leaveConfirm: "Are you sure you want to leave this organization?",

    // Member Management Component
    memberManagement: "Member Management",
    inviteMembers: "Invite Members",
    inviteMember: "Invite Member",
    invitationManagement: "Invitation Management",
    currentMembers: "Current Members",
    memberList: "Member List",
    invitationList: "Invitation List",
    permissionMatrix: "Permission Matrix",
    organizationId: "Organization ID",
    selectOrganization: "Select Organization",
    loadingOrganizations: "Loading...",
    noOrganizations: "No available organizations",
    switchMode: "Switch",
    member: {
      name: "Name",
      email: "Email",
      role: "Role",
      status: "Status",
      joinedAt: "Joined Date",
      editRole: "Edit Role",
      editUser: "Edit Member",
      lastOwnerWarning: "You cannot change the last owner. Please add a new owner first.",
      selfStatusChangeDisabled: "You cannot change your own status.",
      statusActive: "Active",
      statusInactive: "Inactive",
      manageRoleStatus: "Manage the role and status of {{username}} ({{email}}).",
    },
    invitation: {
      email: "Email",
      emailPlaceholder: "e.g., user1@example.com, user2@example.com (multiple)",
      role: "Role",
      sentAt: "Sent Date",
      expiresAt: "Expiration Date",
      status: "Status",
      accepted: "Accepted",
      pending: "Pending",
      invite: "Invite",
      title: "Organization Invitation",
      message:
        'You have been invited to join the organization "{{organization}}" as a {{role}}. Invited by: {{inviter}}.',
      expires_at: "This invitation expires on {{date}}.",
      accept: "Accept",
      decline: "Decline",
      administrator: "Administrator",
    },
    active: "Active",
    suspended: "Suspended",
    pending: "Pending",
    inviteDescription: "Enter the email address and role for the member you want to invite.",
    confirmDeleteMember: "Delete Member",
    confirmDeleteMemberText:
      "Are you sure you want to remove this member from the organization? This action cannot be undone.",
    deleteMember: "Delete Member",
    resendInvitation: "Resend Invitation",
    cancelInvitation: "Cancel Invitation",
    delete: "Delete",
    confirmRemove: "Are you sure you want to remove this member?",
    confirmSuspend: "Are you sure you want to suspend this member?",
    confirmActivate: "Do you want to activate this member?",
    confirmPromote: "Do you want to promote this member?",
    confirmDemote: "Do you want to demote this member?",
    inviteSuccess: "Invitation sent successfully",
    inviteError: "Failed to send invitation",
    error: {
      fetchMembers: "An error occurred while fetching member information.",
      fetchInvitations: "An error occurred while fetching invitation information.",
      updateMember: "An error occurred while updating member information. The last owner cannot be changed.",
      emailRequired: "Please enter an email address.",
      emailInvalid: "Invalid email addresses are included.",
      emailValidationError: "Invalid email address: {{email}}",
      inviteMember: "An error occurred while inviting a member.",
      deleteMember: "An error occurred while deleting the member.",
      resendInvitation: "An error occurred while resending the invitation.",
      cancelInvitation: "An error occurred while canceling the invitation.",
      fetchSettings: "An error occurred while fetching organization settings.",
      saveSettings: "An error occurred while saving settings.",
      fetchUsageData: "An error occurred while fetching usage data.",
      exportData: "An error occurred while exporting data.",
      log: {
        fetchUsageData: "Usage data fetch error:",
        exportData: "Export data error:",
      },
    },
    success: {
      updateMember: "Member information updated successfully",
      deleteMember: "Member deleted successfully",
      resendInvitation: "Invitation resent successfully",
      cancelInvitation: "Invitation canceled successfully",
      saveSettings: "Settings saved successfully",
      updateName: "Organization name updated successfully",
    },

    // Organization Settings Component
    securitySettings: "Security Settings",
    securityLevel: "Security Level",
    securityLevels: {
      standard: "Standard",
      strict: "Strict",
      enterprise: "Enterprise",
    },
    contentFilterStrength: "Content Filter Strength",
    weak: "Weak",
    strong: "Strong",
    featureSettings: "Feature Settings",
    disableImageGeneration: "Disable Image Generation",
    disableVoiceGeneration: "Disable Voice Generation",
    disableCreditPurchases: "Disable Credit Purchases",
    disableAdultContent: "Disable Adult Content",
    defaultSettings: "Default Settings",
    defaultLanguage: "Default Language",
    saving: "Saving...",
    saveSettings: "Save Settings",

    // Organization Features
    organizationFeatures: "Organization Features",
    mindMapEnabled: "Enable Mind Map",
    browsingEnabled: "Enable Browsing (Chat)",
    colorPaletteEnabled: "Enable Color Palette",
    promptTemplateEnabled: "Enable Prompt Template",
    writingAIEnabled: "Enable Writing AI",
    imageGenerationEnabled: "Enable Image Generation",
    videoGenerationEnabled: "Enable Video Generation",
    soundGenerationEnabled: "Enable Sound Generation",
    imageSafetyLevel: "Image Safety Level",
    articlePublishingEnabled: "Enable Article Publishing",
    organizationSettingsOverride: "These settings will override individual user settings",

    // Usage Report Component
    usageReport: "Usage Report",
    period: "Period",
    periods: {
      week: "Week",
      month: "Month",
      quarter: "Quarter",
      year: "Year",
      contract: "Contract Period",
    },
    usageHistory: "Usage History",
    startDate: "Start Date",
    endDate: "End Date",
    selectedMember: "Select Member",
    allMembers: "All Members",
    exportData: "Export Data",
    summary: "Summary",
    totalCreditsUsed: "Total Credits Used",
    memberUsage: "Member Usage",
    dateTime: "Date/Time",
    page: "Page",
    action: "Action",
    credits: "Credits",
    totalCredits: "Total Credits",
    status: "Status",
    charged: "Charged",
    refunded: "Refunded",
    loading: "Loading...",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    last90Days: "Last 90 Days",
    custom: "Custom",
    totalUsage: "Total Usage",
    usedCredits: "Used Credits",
    topUsers: "Top Users",
    user: "User",
    creditsUsed: "Credits Used",
    percentage: "Percentage",
    creditsByFeature: "Credits by Feature",
    feature: "Feature",
    dailyUsage: "Daily Usage",
    noData: "No data available",
    switchToPersonal: "Switch to Personal Mode",

    // Permission Matrix
    permissions: {
      title: "Permission Matrix",
      description: "View detailed permissions assigned to each role.",
      permission: "Permission",
      organizationManagement: "Organization Management",
      organizationSettings: "Change Organization Settings",
      organizationNameChange: "Change Organization Name",
      contractManagement: "Contract Management",
      memberManagement: "Member Management",
      inviteMembers: "Invite Members",
      removeMembers: "Remove Members",
      changeRoles: "Change Roles",
      manageManagers: "Appoint/Remove Managers",
      invitationManagement: "Invitation Management",
      sendInvitations: "Send Invitations",
      resendInvitations: "Resend Invitations",
      reportsAndAnalytics: "Reports & Analytics",
      viewUsageReports: "View Usage Reports",
      viewAllMemberUsage: "View All Member Usage",
      serviceUsage: "Service Usage",
      useAIFeatures: "Use AI Features",
      useCredits: "Use Credits",
      viewOwnUsage: "View Own Usage",
      allowed: "Allowed",
      notAllowed: "Not Allowed",
    },
  },
  // Feature restriction modal
  restriction: {
    title: "Restricted by Administrator",
    message: "This feature ({{feature}}) has been restricted by the administrator.",
  },
  // Feature display names
  features: {
    mindMap: "Mind Map",
    browsing: "Browsing (Chat)",
    colorPalette: "Color Palette",
    promptTemplate: "Prompt Template",
    writingAI: "Writing AI",
    imageGeneration: "Image Generation",
    videoGeneration: "Video Generation",
    voiceGeneration: "Voice Generation",
    soundGeneration: "Sound Generation",
    unknownFeature: "-",
  },
  settings: {
    title: "Settings",
    appearance: "Appearance",
    uiLanguage: "UI Language",
    uiLanguageDescription: "The language of the user interface",
    aiLanguage: "AI Language",
    aiLanguageButton: "Manage AI Language",
    aiLanguageDescription: "The response language of AI",
    aiEngine: "AI Engine Mode",
    aiEngineDescription:
      "Select the AI engine mode for text generation. You can switch between o4-mini, GPT-4.1, Claude 4 Sonnet and GPT-4.1-mini as needed. This setting can be changed at any time from the user icon in the upper right corner.",
    country: "Country",
    countryDescription: "Select a country to optimize search results.",
    switcherLanguageDescription: "Please change the AI's response language from the settings.",
    urlMode: {
      title: "URL Reference Mode",
      description:
        "Selects the mode for AI to reference URLs. The 'strict' mode may consume a large amount of credits.",
      strict: "Strict",
      economy: "Economy",
    },
  },
  planAndBillings: {
    title: "Subscription and Billing",
    credit: "Credit Balance",
    totalCredit: "Total Credits",
    monthlyCredit: "Monthly Credits",
    dailyCredit: "Daily Credits",
    extraCredit: "Extra Credits",
    dailyRefresh: "Daily Refresh",
    subscriptionPeriod: "Subscription Period",
    currentPlan: "Subscription Plan",
    upgrade: "Upgrade",
    billings: "Subscription Billing History",
    cancel: "Cancel Subscription",
    reactivate: "Reactivate Subscription",
    invoice: "View invoices in customer portal",
    noInvoice: "No invoice available.",
    aboutCredit: "About Credits",
    checkoutHistory: "Purchase History",
    checkoutHistoryNote: "Upgrades and credit purchases (past 12 months)",
    receipt: "Receipt",
    document: "Document",
    selectHistory: "Select History",
    pleaseSelect: "Please select",
    resetDate: "Reset Date",
    upgradeModal: {
      title: "Upgrade Plan",
      description: "Upgrading your plan allows access to more features.",
      caution1: "Upgrading will immediately add credits and unlock features.",
      caution2: "If you are already subscribed to a paid plan, the difference will be charged.",
      caution3:
        "The next billing date (credit expiration date) will not change. The next billing date can be checked in the customer portal.",
      caution4:
        "By making a purchase, you are deemed to have agreed to the above terms, privacy policy and conditions, as well as the Terms of Service.",
      price: "Billing amount",
      nextPrice: "Next billing amount",
      newPlan: "New Plan",
      upgrade: "Agree and Upgrade",
      warningJCB: "",
    },
  },
  // Common
  common: {
    ok: "OK",
  },
  misc: {
    title: "MISC",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    contact: "Contact",
    startContact: "Start Contact",
    confirm: "Confirm",
    contactModal: {
      title: "Contact Us",
      description: "Please enter your inquiry.",
      warn: "Please note that we cannot respond to general inquiries about AI usage or consultation, other than questions about Tenak AI.",
      subject: "Title",
      type: {
        description: "Please select the type of inquiry.",
        question: "Question",
        problem: "Report a Problem",
        payment: "Regarding Payment",
        request: "Feedback and Requests",
        enterprise: "Regarding Enterprise",
        other: "Other",
      },
      name: "Name",
      email: "Email Address",
      message: "Details of Inquiry",
      send: "Send",
      error: "Failed to send your inquiry. Please try again later.",
      success: "Your inquiry has been received. We will contact you shortly.",
    },
  },
};
export default preference;
